import React from 'react';
import classNames from 'classnames';
import s from './index.module.scss';
import tag1 from './img/tag1.svg';
import tag2 from './img/tag2.svg';
import tag3 from './img/tag3.svg';
import tag4 from './img/tag4.svg';

function Tag (props) {
	const { index, title, text } = props;

	const images = {
		1: tag1,
		2: tag2,
		3: tag3,
		4: tag4
	};

	return (
		<div className={s.tag}>
			<img src={images[index]} alt="" />
			<div className={s.tag__title}>{title}</div>
			<div className={classNames(s.tag__text, index === 2 && s.tag__text_2)}>{text}</div>
		</div>
	);
}

export default Tag;
